import React from 'react';
import { string, bool, array, oneOfType } from 'prop-types';

const SortItemMobile = ({ value, isRefined, label }) => (
    <option value={value} data-sort-value={value} defaultValue={isRefined}>
        {label}
    </option>
);

SortItemMobile.propTypes = {
    value: oneOfType([string, array]).isRequired,
    isRefined: bool,
    label: string.isRequired,
};

SortItemMobile.defaultProps = {
    isRefined: false,
};

export default SortItemMobile;
